import React, { useEffect, useState , useMemo } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import {
  resetMasterdashData_internal,
  resetMasterdashData_Crud_opretions,
  setTablePositionPersist
} from "../../../Redux/Slice";
import ReactTable from "../../AppComponent/Table";
import Delete from "../../AppComponent/Popup/Delete";
import _ from "lodash";
import EditImages from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-04 (1).svg";
import { Mastercruds } from "./Mastercruds";
import DeleteImages from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-05.svg";


const Masterdashlist = () => {
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );
  const dispatch = useDispatch();
  const state = useSelector((state) => state);
      const TablePositionPersist = useSelector(
      (state) => state.PreviousPagePosition.TablePositionPersist
    )
  const [currentPage, setCurrentPage] = useState(1);
  const [Datas, setDatas] = useState([]);
  const [DeleteID, setDeleteId] = useState();
  const [DeletePopup, setDeletePopup] = useState(false);
  const [UserCreate, setUserCreate] = useState(false);
  const [UserEditPopup, setUserEditPopup] = useState(false);
  const [EditId, setEditID] = useState();

const [dtpageindex, setdtPageindex] = useState(
    TablePositionPersist?.MasterDashboard_datas?.page == undefined
      ? 1
      : TablePositionPersist.MasterDashboard_datas.page
  );

const [search, setsearch] = useState(
    TablePositionPersist?.MasterDashboard_datas?.search == undefined ||
    TablePositionPersist?.MasterDashboard_datas?.search ==""
      ? ""
      : TablePositionPersist.MasterDashboard_datas.search
  ); 
   

  const [dtpagesize, setdtPagesize] = useState(20);
  const [pageSize, setPageSize] = useState(20);
const [retrievedata , setretrievedata] = useState(null)
  useEffect(() => {
    const payload = {
      search: search,
      page_size: 20,
      page: dtpageindex,
    };
    dispatch(resetMasterdashData_internal(payload));
       dispatch(
                  setTablePositionPersist({
                    data: payload,
                    pageName: "MasterDashboard_datas",
                  })
                );

  }, [dtpageindex , search]);
  console.log(TablePositionPersist.MasterDashboard_datas ,
    "TablePositionPersist.MasterDashboard_datas"
  );
  

  const pagesize = (arg) => {
    setdtPagesize(arg);
  };

  const pageindex = (arg) => {
    setdtPageindex(arg);
  };

  const debouncedSearch = useMemo(
    () =>
      _.debounce((e) => {
       setsearch(e);
      }, 500),
    []
  );


  // -----Search------------------------
  function tochange(e) {
setdtPageindex(1);
debouncedSearch(e);  }

  React.useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);


  const columns = [
    {
      Header: "Name",
      accessor: "first_name",
    },
    {
      Header: "Email",
      accessor: "email",
    },
    {
      Header: "Actions",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            <div
              class="actions"
              style={{
                display: "flex",
                justifyContent: "flex-start",
                gap: "5px",
              }}
            >
              <button
                className=" btn Status"
                component="span"
                onClick={(e) => {
                  e.stopPropagation();
                  setUserEditPopup(true);
setretrievedata(row.row.original)
                  setEditID(row.row.original.id);
                }}
              >
                            <span className="OuterActionSpan">
                            <span  className="EditImages">
                    <img src={EditImages}/>
                  </span>
                  <span className="ActionsList"> Edit </span>
                </span>
              </button>


          
              <button
                type="button"
                class="btn Status"
                onClick={(e) => {
                  e.stopPropagation();
                  setDeleteId(row.row.original.id);
                  setDeletePopup(true);
                }}
              >
                <span className="OuterActionSpan">

                  <span className="EditImages">
                    <img src={DeleteImages} />
                  </span>

                  <span className="ActionsList"> Delete </span>
                </span>
              </button>
  
            </div>
          </>
        );
      },
    },
  ];


  const handleNext = (next) => {    
    setdtPageindex(next + 1);
};

const GotoEnteredPage =(gotopage)=>{
 setdtPageindex(gotopage)
}

const handlePrevious = (previous) => {
if (previous != 0) {
  setdtPageindex(previous);

}
};


  const HandleSubmits = () => {
    if (DeleteID != undefined) {
                  setsearch("");
                  setdtPageindex(1);
      dispatch(resetMasterdashData_Crud_opretions({
          payload:{ 
          method: "delete" , 
          id: DeleteID,
          Funcations: () => {
          setDeletePopup(false)
        },
        listParams: {
        search:"",
        page_size: 20,
        page: 1,
          },}}));}
          };

  // console.log(state.AdminuseraccesslistCall, "AdminuseraccesslistCall");

  return (
    <>
      <div className={stateDisplay ? "outterContent" : "inner-Content"}>
        <div
          className="Header-Details ClientBranch row"
          style={{ padding: "14px 28px" }}
        >
          <div
            class="col-sm-7 auto"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "flex-start",
            }}
          >
            <h3>Master Dashboard </h3>

          </div>
          <div className="Add-User col-sm-5">
            <button onClick={(e) => {setUserCreate(true);
setretrievedata(null)


            }} className="ButtonCSS">
              Create
            </button>
          </div>
        </div>
        <br/>

        <div
          style={{ padding: " 0px 40px", marginTop: "-13px" }}
        >
          <ReactTable
            data={state.masterdashboard_records.Master_dashboard}
            columns={columns}
            totalItems={state.masterdashboard_records.MasterDash_total_count}
            currentPage={currentPage}
            onChange={tochange}
            setCurrentPage={setCurrentPage}
            pagesize={pagesize}
            onPrevious={handlePrevious}
              onNextpage={handleNext}
              GotoEnteredPage={GotoEnteredPage}
            dtpagesize={pageSize}
            dtpageindex={dtpageindex}
            pageindex={pageindex}
            datacount={state.masterdashboard_records.MasterDash_total_count}            
            Filter={true}
            NoFilter ={true}
            MakeCreate={false}
                                searchVal={TablePositionPersist?.MasterDashboard_datas?.search == "" || TablePositionPersist?.MasterDashboard_datas?.search ==undefined? "":TablePositionPersist.MasterDashboard_datas.search}
              search_key={true}


          />
        </div>
      </div>
      {UserCreate ? (
        <Mastercruds
          show={UserCreate}
          setShow={setUserCreate}
          dtpageindex={dtpageindex}
          Number={state.AdminuseraccesslistCall.Total_Count + 1}
                     retrievedata={retrievedata}           search={search}

        />
      ) : null}

      {UserEditPopup && EditId != undefined ? (
        <Mastercruds
          show={UserEditPopup}
          setShow={setUserEditPopup}
          EditId={EditId}
          Number={state.AdminuseraccesslistCall.Total_Count + 1}
          dtpageindex={dtpageindex}
           search={search}
           retrievedata={retrievedata}
        />
      ) : null}

      {DeletePopup ? (
        <Delete
          show={DeletePopup}
          setShow={setDeletePopup}
          onSubmit={HandleSubmits}
          Content={"Do you want to delete admin details"}
        />
      ) : null}
    </>
  );
};

export default Masterdashlist;
